import { defineStore } from 'pinia';

type StoreStateType = {
	device?: string;
};
export const useDeviceStore = defineStore('device', {
	state: (): StoreStateType => {
		return {
			device: '',
		};
	},
	getters: {
		getDevice(state) {
			return state.device;
		},
	},
	actions: {
		setDevice(device: string) {
			this.device = device;
		},
		resetAuth() {
			this.$reset();
		},
	},
	persist: true,
});
